import React from 'react';

export const ValidationContext = React.createContext(null);